import {useParams} from "react-router-dom";
import EditQRCode from "../../../components/qr-code/edit/EditQRCode";

type QueryParams = {
    id: string;
};

/**
 * Page to edit existing QR code.
 * @route /qr-code/edit/:id
 * @author Kacper Faber
 * @since 0.2.0
 */
function EditQrCodePage() {
    /**
     * Query parameters
     * @author Kacper Faber
     * @since 0.2.0
     */
    const params = useParams<QueryParams>();

    return (
        <EditQRCode
            id={params.id}
        />
    );
}

export default EditQrCodePage;